module.exports = __webpack_public_path__ + "media/images/lb/759-1345ff3e07e1ce5390caa100d4f16f6d.svg";